// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__346D5","content":"styles_content__3iEKA"};